import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -8","key":"svg-0"}],["path",{"d":"M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2","key":"svg-1"}]]

const IconLayersSubtract = createReactComponent('outline', 'layers-subtract', 'LayersSubtract', __iconNode);

export default IconLayersSubtract;